import React, { FC, useCallback } from 'react';
import { useDataTableQuickActionsContext } from '../../utils/DataTableQuickActionsContext';
import { useDataTableQuickReportsContext } from '../../utils/DataTableQuickReportsContext';
import { AddQuickReportDialog } from '../DataTableQuickReports/Dialog/AddQuickReportDialog';
import { getActiveQuickReport } from '../DataTableQuickReports/utils/QuickReports.utils';
import { DataTableRowActions, DataTableRowAction } from '../DataTableRowActions';
import { useIntlUds } from '../../../../translations/UdsIntlProvider';

export const DataTableSaveFilters: FC<React.PropsWithChildren<unknown>> = () => {
  const { activeQuickReportId, unSavedQuickReport, quickReports } = useDataTableQuickReportsContext();
  const { quickReport, setQuickReport, saveNewQuickReport, saveCurrentQuickReport, undoChanges } =
    useDataTableQuickActionsContext();
  const { intl } = useIntlUds();

  const onClickHandler = useCallback(
    (selectedMenuItem: 'save' | 'save-as') => {
      if (selectedMenuItem === 'save-as') {
        const quickReportToClone = !activeQuickReportId
          ? unSavedQuickReport
          : getActiveQuickReport(quickReports, activeQuickReportId);
        setQuickReport({
          name: `CLONE-${quickReportToClone?.name}`,
          quickReportId: quickReportToClone?.quickReportId,
          actionType: 'Save as'
        });
      }

      if (selectedMenuItem === 'save') {
        saveCurrentQuickReport();
      }
    },
    [saveCurrentQuickReport, setQuickReport, unSavedQuickReport, quickReports, activeQuickReportId]
  );

  return Array.isArray(quickReports) ? (
    <>
      <AddQuickReportDialog
        saveQuickReport={quickReport}
        setSaveQuickReport={setQuickReport}
        onSave={saveNewQuickReport}
      />

      <DataTableRowActions dataTest="quick-report-actions-button">
        {!activeQuickReportId && (
          <DataTableRowAction
            dataTest="quick-report-save"
            onClick={() => setQuickReport({ name: '', actionType: 'Add' })}
          >
            {intl.DataTable.QuickViews.action.save}
          </DataTableRowAction>
        )}
        {activeQuickReportId && (
          <>
            <DataTableRowAction
              dataTest="quick-report-save"
              disabled={!unSavedQuickReport}
              onClick={() => onClickHandler('save')}
            >
              {intl.DataTable.QuickViews.action.save}
            </DataTableRowAction>
            <DataTableRowAction dataTest="quick-report-save-as" onClick={() => onClickHandler('save-as')}>
              {intl.DataTable.QuickViews.action.saveAs}
            </DataTableRowAction>
            <DataTableRowAction
              dataTest="quick-report-undo-changes"
              disabled={!unSavedQuickReport}
              onClick={undoChanges}
            >
              {intl.DataTable.QuickViews.action.undoChanges}
            </DataTableRowAction>
          </>
        )}
      </DataTableRowActions>
    </>
  ) : null;
};
